export default function Areas({ areas, selectArea, selectedArea, host }) {
  const AreaItem = ({ area }) => {
    const iconImg = host + area.icon;
    const iconHover = host + area.icon_hover;
    const isSelected = selectedArea && area.slug === selectedArea;

    return (
      <div
        onClick={() => selectArea(area)}
        className={`flex flex-col items-center cursor-pointer transition-all duration-150 ${
          isSelected ? 'pointer-events-none' : ''
        }`}
      >
        <div className="relative !w-32 h-32">
          <img
            className={`absolute top-0 left-0 w-full h-full transition-opacity duration-300 ease-in-out ${
              isSelected ? 'opacity-0' : 'opacity-100 hover:opacity-0'
            }`}
            src={iconImg}
            alt={area.title}
          />
          <img
            className={`absolute top-0 left-0 w-full h-full transition-opacity duration-300 ease-in-out ${
              isSelected ? 'opacity-100' : 'opacity-0 hover:opacity-100'
            }`}
            src={iconHover}
            alt={area.title}
          />
        </div>
        <p className="!text-xl pt-2 text-teal-900 text-center">{area.title}</p>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-2 justify-items-center sm:grid-cols-4 gap-10 mb-8 lg:mb-12">
      {areas.map((area, index) => (
        <AreaItem area={area} key={`area_${index}`} />
      ))}
    </div>
  );
}